<!-- Page banner Area -->
<div class="page-banner bg-7">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-content service-banner-content">
                    <h2>Volumetric Weight Calculator</h2>
                    <!-- <ul>
                        <li><a routerLink="/">Home</a></li>
                        <li>Air fright</li>
                    </ul> -->
                </div>
            </div>
        </div>
    </div>
</div>

<div class="container-fluid mt-5 mb-5">
     <h1 class="mb-5 pb-2 border-bottom border-dark">Volumetric Weight Calculator Services</h1>

    <p>The transport costs for your shipments are calculated on the premise of the whole weight of all bundles. A
        definitive figure for calculating is-does the dimentional weight surpasses the real weight of your bundle?
    </p>

    <p>To form the foremost cost-effective shipping decision, simply enter your bundle data underneath, and we are going
        calculate the volumetric weight for you.</p>

    <!-- MAIN ROW -->
    <div class="row g-4 mt-2">

        <!-- LEFT SIDE -->
        <div class="col-12 col-md-6">
            <h3 class="text-center text-md-start">Volume Converter</h3>

            <form class="custom-form pb-4" [formGroup]="volumetricForm">

                <label class="text-center text-md-start d-block form-label">
                    Enter the Dimensions (in inches) :
                </label>

                <!-- MOBILE STACK FIX -->
                <div class="row g-2">
                    <div class="col-12 col-sm-4">
                        <input id="length" type="number" formControlName="length" (wheel)="stopScrollingWheel($event)"
                            name="length" class="form-control text-sm-start" placeholder="Length">
                    </div>

                    <div class="col-12 col-sm-4">
                        <input id="width" type="number" formControlName="width" (wheel)="stopScrollingWheel($event)"
                            name="width" class="form-control text-sm-start" placeholder="Width">
                    </div>

                    <div class="col-12 col-sm-4">
                        <input type="number" formControlName="height" (wheel)="stopScrollingWheel($event)"
                            class="form-control  text-sm-start" placeholder="Height">
                    </div>
                </div>

                <div class="form-group pt-3">
                    <label class="form-label" for="volume_result">Dimensional Weight Results :</label>
                    <input id="volume_result" disabled formControlName="volume_result" type="text" class="form-control "
                        placeholder="0">
                </div>

                <div class="form-group pt-3">
                    <label class="form-label" for="disabledTextInput" class="mt-2">L x W x H (cubic inches) / 139= Dimensional Weight.
                        Example: 30" x 24" x 22" = 15,840 / 139 = 114 lbs. (round up to the nearest pound).</label>
                    <!-- <input disabled type="text" id="disabledTextInput" class="form-control" placeholder="Disabled input" value=""> -->
                </div>

                <!-- BUTTON FULL WIDTH MOBILE -->

                <button type="button" value="Calculate" class="btn btn-blink d-md-inline-block mt-3"
                    (click)="calculate()">
                    <span>Submit</span>
                    <i class="bi bi-arrow-right"></i>
                </button>

            </form>
        </div>

        <!-- RIGHT SIDE -->
        <div class="col-12 col-md-6">
            <h3 class="text-center text-md-start">Weight Converter</h3>

            <form class="custom-form pb-4 ps-md-3" [formGroup]="unitForm">

                <div class="form-group mb-3">
                    <label class="form-label" for="disabledTextInput">Input Unit :</label>
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-select formControlName="input_unit" (selectionChange)="onChangeUnit($event)" placeholder="Choose...">
                            <mat-option value="Kg">Kg</mat-option>
                            <mat-option value="Pound">Pound</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <!-- MOBILE STACK FIX -->
                <div class="row align-items-end">
                    <div class="col-12">
                        <label for="disabledTextInput" class="form-label">Value :</label>
                        <input id="weight_value" type="number" formControlName="weight_value"
                            (wheel)="stopScrollingWheel($event)" name="value" class="form-control text-md-start"
                            placeholder="Enter Value">
                    </div>

                    <div class="col-12">
                        <button type="button" value="Calculate" class="btn btn-blink d-md-inline-block mt-3"
                            (click)="calculateUnit()">
                            <span>Calculate</span>
                            <i class="bi bi-arrow-right"></i>
                        </button>
                    </div>
                </div>

                <div id="wg_message" class="form-group">
                    <!-- <input disabled type="text" style="border: 1px solid #ff7171; background-color:#ffb9b9;" class="form-control" placeholder="Error"> -->
                    <!-- <input disabled type="text" style="border: 1px solid #48d64d; background-color:#88d78b;" class="form-control" placeholder="Sucess"> -->

                </div>
                <div class="row g-3 pt-2 mt-3">
                    <div class="col-12 col-md-6">
                        <label class="form-label" for="inlineFormCustomSelect">Kilogram : </label>
                        <input disabled="" type="number" formControlName="kg" (wheel)="stopScrollingWheel($event)"
                            id="kilogram" class="form-control" placeholder="0">
                    </div>

                    <div class="col-12 col-sm-6">
                        <label class="form-label" for="inlineFormCustomSelect">Pound : </label>
                        <input disabled="" type="number" formControlName="pound" id="pound" class="form-control"
                            placeholder="0">
                    </div>
                </div>
            </form>
        </div>
    </div>

</div>

<!-- Single Service Area -->

<!-- End Single Service Area -->

<!-- Newsletter Area -->
<div class="newsletter-area">
    <div class="container">
        <div class="newsletter-content">
            <div class="row align-items-center">
                <!-- <div class="col-lg-5 col-md-12">
                    <div class="newsletter-title">
                        <h3>Subscribe to our newsletter:</h3>
                        <p>Focused on the transport and logistic industry</p>
                    </div>
        </div>

                <div class="col-lg-7 col-md-12">
                    <form class="newsletter-form">
                        <input type="email" class="form-control" placeholder="Enter your email" name="EMAIL" required=""
                            autocomplete="off">
                        <button type="submit" class="btn btn-primary">Subscribe</button>
                    </form>
                </div> -->
            </div>
        </div>
    </div>
</div>
<!-- End Newsletter Area -->